import { CSharpLanguage as CSharpLanguage } from "./CSharpLanguage";
import { SteamworksNetLibrary } from "./SteamworksNetLibrary";

export class UnityLibrary
{
  public static readonly token = "unity";
  public static keywords:string[] = 
  CSharpLanguage.keywords.concat(
    [
      "Vector2","Vector3","Vector4",
      "Transform","MonoBehaviour","GameObject",
      "Undo",
      "PrefabUtility",
    ].concat( SteamworksNetLibrary.keywords )
  )
  
}